import { NgModule } from "@angular/core";
import { LgSlideoutComponent } from "./lg-slideout.component";
import { LgSlideoutHolderComponent } from "./lg-slideout-holder.component";
import { LgSlideoutButtonRowComponent } from "./lg-slideout-button-row.component";
import { LgSlideoutHolderHeaderComponent } from "./lg-slideout-holder-header.component";

@NgModule({
    imports: [
        LgSlideoutComponent,
        LgSlideoutHolderComponent,
        LgSlideoutButtonRowComponent,
        LgSlideoutHolderHeaderComponent
    ],
    exports: [
        LgSlideoutComponent,
        LgSlideoutHolderComponent,
        LgSlideoutButtonRowComponent,
        LgSlideoutHolderHeaderComponent
    ]
})
export class LgSlideoutModule {
    // empty
}
